'use strict';

import { playSoundEffect } from '../hooks/useSoundEffects';
import './pvpMatchInterruptNotice.css';

/** Stay on current screen this long before navigating to the PvP battle. */
export const PVP_MATCH_INTERRUPT_NOTICE_MS = 2000;

const NOTICE_EXIT_MS = 280;

function waitForNextPaint() {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame !== 'function') {
      resolve();
      return;
    }
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });
}

/**
 * Full-screen interrupt notice (imperative DOM — safe inside lobby WebSocket handlers).
 * @param {string} message
 * @returns {Promise<void>}
 */
export async function showPvpMatchInterruptNotice(message) {
  if (!message) {
    throw new Error('showPvpMatchInterruptNotice: message is required');
  }
  if (typeof document === 'undefined') {
    await new Promise((resolve) => {
      setTimeout(resolve, PVP_MATCH_INTERRUPT_NOTICE_MS);
    });
    return;
  }

  const backdrop = document.createElement('div');
  backdrop.className = 'pvp-match-interrupt-backdrop';
  backdrop.setAttribute('role', 'alertdialog');
  backdrop.setAttribute('aria-live', 'assertive');
  backdrop.setAttribute('aria-modal', 'true');

  const dialog = document.createElement('div');
  dialog.className = 'pvp-match-interrupt-dialog';

  const messageEl = document.createElement('p');
  messageEl.className = 'pvp-match-interrupt-message';
  messageEl.textContent = message;
  dialog.appendChild(messageEl);
  backdrop.appendChild(dialog);
  document.body.appendChild(backdrop);

  try {
    playSoundEffect('/sounds/click.mp3', 0.3);
  } catch {
    /* ignore sound errors */
  }

  await waitForNextPaint();
  await new Promise((resolve) => {
    setTimeout(resolve, PVP_MATCH_INTERRUPT_NOTICE_MS);
  });

  backdrop.classList.add('pvp-match-interrupt-backdrop-exit');
  dialog.classList.add('pvp-match-interrupt-dialog-exit');
  await new Promise((resolve) => {
    setTimeout(resolve, NOTICE_EXIT_MS);
  });
  backdrop.remove();
}
